import { Component, OnInit } from '@angular/core';
import { UserLogin, User } from '../../component/model/user-login';
import { AuthServiceService } from '../../component/service/auth-service.service';
import { UserService } from '../../section/user/service/user.service';
@Component({
  selector: 'app-foget-password',
  templateUrl: './foget-password.component.html',
  styleUrls: ['./foget-password.component.css']
})
export class FogetPasswordComponent implements OnInit {

  errorMsg : string = '';
  successMsg : string = '';
  user : User = new User('','');
  authService : AuthServiceService;
  userService : UserService;
  loading : boolean = false;
  constructor(authorizationService : AuthServiceService, _userSrv :UserService) {
    this.authService = authorizationService;
    this.userService = _userSrv;
   }
  
  ngOnInit() {
    $('body').addClass("login-page authentication");
  }
  getPassword() {
    this.loading = true;
    this.errorMsg = ""; 
    this.userService.getForgetPassword(this.user.email).subscribe(data=> {
      this.user.email = "";
       this.successMsg = "Password has been sent to your registered mail address!";
        // this.router.navigate(['main']);
      this.loading = false;
     }, error=> {
      this.errorMsg = JSON.parse(error._body).Message;
      this.loading = false;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/section/foget-password/foget-password.component.ts